// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style-module--titleWrapper--2oB2F","titleDescription":"style-module--titleDescription--1-ShH","itemsWrapper":"style-module--itemsWrapper--2FzM8"};